import { Box } from '@mui/material';
import React from 'react';
import { GlobalConfiguration } from '../../../models/GlobalConfiguration';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledSwitch } from '../../styles/StyledInputs';
import StyledSection from '../../styles/StyledSection';
import { StyledFieldRow, StyledHeading, StyledLabel } from '../../styles/styles';
import ConfigFieldLabel from './ConfigFieldLabel';
import { FEATURE_SWITCH_FIELDS, GLOBAL_CONFIG_FIELD_LABELS } from './globalConfigFieldConfig';

type FeatureSwitchesSectionProps = {
  config: GlobalConfiguration;
  dirtyFields: Set<string>;
  onChange: (field: string, value: unknown) => void;
};

export default function FeatureSwitchesSection({
  config,
  dirtyFields,
  onChange,
}: FeatureSwitchesSectionProps) {
  return (
    <StyledSection tone="tone1">
      <StyledHeading tone="tone1" headerVariant="heading2">
        Feature Switches
      </StyledHeading>
      {FEATURE_SWITCH_FIELDS.map((fieldKey) => (
        <StyledFieldRow unrestrictedWidth sx={{ mb: 2 }} key={fieldKey}>
          <StyledSwitch
            checked={!!(config as unknown as Record<string, unknown>)[fieldKey]}
            onChange={(e) => onChange(fieldKey, e.target.checked)}
          />
          <Box sx={{ ml: 2 }}>
            <StyledLabel unrestricted>
              <ConfigFieldLabel
                fieldKey={fieldKey}
                label={GLOBAL_CONFIG_FIELD_LABELS[fieldKey]}
                dirtyFields={dirtyFields}
              />
            </StyledLabel>
            <StyledFieldDescription stacked>
              Enables the {GLOBAL_CONFIG_FIELD_LABELS[fieldKey]} feature for users.
            </StyledFieldDescription>
          </Box>
        </StyledFieldRow>
      ))}
    </StyledSection>
  );
}
